import { FC, ReactNode } from 'react';
import { Link } from '@vs-online-only-app/ui';
import { isValueAnEmail } from '../../Login/LoginForm';

type Props = {
  email?: string;
  to: string;
  children: ReactNode;
};

const EmailLink: FC<Props> = ({ email, to, children }) => {
  const isValidEmail = email && isValueAnEmail(email);
  const linkWithQueryParam = `${to}${isValidEmail ? `?email=${encodeURIComponent(email)}` : ''}`;

  return (
    <Link to={linkWithQueryParam} variant="body2" sx={{ margin: 'auto' }}>
      {children}
    </Link>
  );
};

export default EmailLink;
